import { memo } from "react";
import { selectIsMeBroadcaster } from "modules/broadcaster";
import { useSelector } from "react-redux";
import {
  selectIsEventManager,
  selectIsEventSpeaker,
} from "modules/event/selectors";
import AttendeeButtons from "./AttendeeButtons";
import { ManagerButtons } from "./ManagerButtons";

const BroadcastMenu = memo(() => {
  const isEventManager = useSelector(selectIsEventManager);
  const isEventSpeaker = useSelector(selectIsEventSpeaker);
  const isMeBroadcaster = useSelector(selectIsMeBroadcaster);

  return isMeBroadcaster || isEventManager || isEventSpeaker ? (
    <ManagerButtons isEventManager={isEventManager} />
  ) : (
    <AttendeeButtons />
  );
});

export default BroadcastMenu;
